(function() {
    'use strict';

    angular
        .module('ipmApp')
        .controller('RequestActivityReportController', RequestActivityReportController);

    RequestActivityReportController.$inject = ['ActivityReportService', '$stateParams', '$state', 'User', 'serviceType'];

    function RequestActivityReportController (ActivityReportService, $stateParams, $state, User, serviceType) {
        var vm = this;
        vm.download = download;
        vm.isUserRequest = false;
        vm.noPdf = false;
        vm.serviceType = serviceType;

        init();

        function init() {
            vm.fileId = $stateParams.id;
            User.getUserByCurrentLogin().then(function (response) {
                var currentUser = response;
                vm.isUserRequest = currentUser.id === Number($stateParams.user);
                if (!vm.isUserRequest) {
                    $state.go('home');
                }
            });
        }

        function download() {
            ActivityReportService.downloadReport(vm.fileId, vm.serviceType).then(function(res) {
                vm.isProcessing = false;
                if(res === 204) {
                    vm.noPdf = true;
                }
            });
        }
    }
})();
